import { render, staticRenderFns } from "./ViewResellerPaymentPage.vue?vue&type=template&id=2507fd5c"
import script from "./ViewResellerPaymentPage.vue?vue&type=script&lang=js"
export * from "./ViewResellerPaymentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports